import {
    FETCH_PRODUCT_CATEGORIES_START,
    FETCH_PRODUCT_CATEGORIES_SUCCESS,
    FETCH_PRODUCT_CATEGORIES_ERROR,
    CREATE_PRODUCT_CATEGORY_START,
    CREATE_PRODUCT_CATEGORY_SUCCESS,
    CREATE_PRODUCT_CATEGORY_ERROR,
    UPDATE_PRODUCT_CATEGORY_START,
    UPDATE_PRODUCT_CATEGORY_SUCCESS,
    UPDATE_PRODUCT_CATEGORY_ERROR,
    DELETE_PRODUCT_CATEGORY_START,
    DELETE_PRODUCT_CATEGORY_SUCCESS,
    DELETE_PRODUCT_CATEGORY_ERROR,
    SET_CATEGORIES_FILTERS,
    CLEAR_CATEGORIES_FILTERS
} from '../actions';

const initialState = {
    categories: [],
    loading: false,
    error: null,
    pagination: {
        current: 1,
        pageSize: 50,
        total: 0
    },
    total: 0,
    filters: {
        searchText: '',
        statusFilter: 'all',
        codeFilter: 'all',
        productLineFilter: 'all',
        sortBy: 'createdAt',
        sortOrder: 'DESC',
        page: 1,
        pageSize: 50
    }
};

const productCategoriesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PRODUCT_CATEGORIES_START:
        case CREATE_PRODUCT_CATEGORY_START:
        case UPDATE_PRODUCT_CATEGORY_START:
        case DELETE_PRODUCT_CATEGORY_START:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_PRODUCT_CATEGORIES_SUCCESS:
            // Create unified pagination from response
            const responsePagination = action.payload.pagination || {};
            const newPagination = {
                current: responsePagination.current || responsePagination.page || state.pagination.current,
                pageSize: responsePagination.pageSize || responsePagination.limit || state.pagination.pageSize,
                total: action.payload.total || responsePagination.total || 0
            };
            
            return {
                ...state,
                loading: false,
                categories: action.payload.categories || [],
                pagination: newPagination,
                total: newPagination.total,
                error: null
            };

        case CREATE_PRODUCT_CATEGORY_SUCCESS:
            return {
                ...state,
                categories: [...state.categories, action.payload],
                loading: false,
                error: null
            };

        case UPDATE_PRODUCT_CATEGORY_SUCCESS:
            return {
                ...state,
                categories: state.categories.map(cat => 
                    cat.id === action.payload.id ? action.payload : cat
                ),
                loading: false,
                error: null
            };

        case DELETE_PRODUCT_CATEGORY_SUCCESS:
            return {
                ...state,
                categories: state.categories.filter(cat => cat.id !== action.payload),
                loading: false,
                error: null
            };

        case SET_CATEGORIES_FILTERS:
            const newFilters = {
                ...state.filters,
                ...action.payload
            };
            
            // Update pagination current/pageSize if they're in filters
            let updatedPagination = { ...state.pagination };
            if (action.payload.page) {
                updatedPagination.current = action.payload.page;
            }
            if (action.payload.pageSize) {
                updatedPagination.pageSize = action.payload.pageSize;
            }
            
            return {
                ...state,
                filters: newFilters,
                pagination: updatedPagination
            };

        case CLEAR_CATEGORIES_FILTERS:
            return {
                ...state,
                filters: {
                    searchText: '',
                    statusFilter: 'all',
                    codeFilter: 'all',
                    productLineFilter: 'all',
                    sortBy: 'createdAt',
                    sortOrder: 'DESC',
                    page: 1,
                    pageSize: state.pagination.pageSize || 50
                },
                pagination: {
                    ...state.pagination,
                    current: 1
                }
            };

        case FETCH_PRODUCT_CATEGORIES_ERROR:
        case CREATE_PRODUCT_CATEGORY_ERROR:
        case UPDATE_PRODUCT_CATEGORY_ERROR:
        case DELETE_PRODUCT_CATEGORY_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        default:
            return state;
    }
};

export default productCategoriesReducer;
